module.exports = __webpack_public_path__ + "static/media/p5_7.57ea979c.jpeg";